// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: #fff;
  height: 8em;
  width: 100%;
  padding: 2em;
  box-shadow: -1px 2px 9px -1px rgba(146, 146, 146, 0.6);
  -webkit-box-shadow: -1px 2px 9px -1px rgba(146, 146, 146, 0.6);
  -moz-box-shadow: -1px 2px 9px -1px rgba(146, 146, 146, 0.6);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
}
.header-logo-container {
  display: flex;
  cursor: pointer;
}
.header-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #920942;
  margin: 0.2em;
}
.header-app {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.2em;
}
.header .button-profile {
  align-self: flex-end;
  background-color: rgba(255, 255, 255, 0);
  border: 0px solid rgba(255, 255, 255, 0);
}

.option-label {
  align-self: flex-start;
  text-align: left;
  margin: 0px 0px 0px 0px !important;
  font-size: 15px;
}

.link {
  text-decoration: none;
  color: #212529;
  align-self: flex-start;
  background-color: rgba(0, 0, 0, 0);
  padding: 8px 12px 0px 12px;
}

.link:hover {
  color: #212529;
}

.label-button-logout {
  align-self: flex-end;
  color: rgb(143, 0, 60);
  padding: 0px;
  margin: 0px;
}

.popover-header-user {
  background-color: rgb(255, 255, 255);
  display: flex;
  align-content: flex-start;
  align-items: flex-start;
}

.body-popover {
  border: 0px solid rgba(0, 0, 0, 0);
  padding: 5px;
}

.button-popover {
  border: 0px solid rgba(0, 0, 0, 0);
}

.popover-box {
  border-radius: 0px;
}

.header-username {
  display: flex;
  align-content: center;
}

.header-username-arrow {
  color: #8f003c;
}`, "",{"version":3,"sources":["webpack://./src/components/header/header.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;EACC,sBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sDAAA;EACA,8DAAA;EACA,2DAAA;ECTA,aAAA;EACA,8BDSc;ECRd,mBDQ6B;EAC7B,UAAA;AAAD;AAEC;EACC,aAAA;EACA,eAAA;AAAF;AAGC;EClBA,aAAA;EACA,uBDkBe;ECjBf,mBDiBuB;EACtB,cElBW;EFmBX,aAAA;AACF;AAEC;ECxBA,aAAA;EACA,uBDwBe;ECvBf,mBDuBuB;EACtB,aAAA;AAEF;AAGC;EACC,oBAAA;EACA,wCAAA;EACA,wCAAA;AADF;;AAKA;EACC,sBAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;AAFD;;AAKA;EACC,qBAAA;EACA,cAAA;EACA,sBAAA;EACA,kCAAA;EACA,0BAAA;AAFD;;AAKA;EACC,cAAA;AAFD;;AAKA;EACC,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAFD;;AAKA;EACC,oCAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;AAFD;;AAKA;EACC,kCAAA;EACA,YAAA;AAFD;;AAKA;EACC,kCAAA;AAFD;;AAKA;EACC,kBAAA;AAFD;;AAKA;EACC,aAAA;EACA,qBAAA;AAFD;;AAKA;EACC,cE3FU;AFyFX","sourcesContent":["@import '../../sass/globals/globals.scss';\n@import '../../sass/globals/mixins.scss';\n\n.header {\n\tbackground-color: $white;\n\theight: 8em;\n\twidth: 100%;\n\tpadding: 2em;\n\tbox-shadow: -1px 2px 9px -1px rgba(146, 146, 146, 0.6);\n\t-webkit-box-shadow: -1px 2px 9px -1px rgba(146, 146, 146, 0.6);\n\t-moz-box-shadow: -1px 2px 9px -1px rgba(146, 146, 146, 0.6);\n\t@include flex(space-between, center);\n\tz-index: 2;\n\n\t&-logo-container {\n\t\tdisplay: flex;\n\t\tcursor: pointer;\n\t}\n\n\t&-logo {\n\t\t@include flex(center, center);\n\t\tcolor: $logo-color;\n\t\tmargin: 0.2em;\n\t}\n\n\t&-app {\n\t\t@include flex(center, center);\n\t\tmargin: 0.2em;\n\t}\n\n\t&-user {}\n\n\t.button-profile {\n\t\talign-self: flex-end;\n\t\tbackground-color: rgba(255, 255, 255, 0);\n\t\tborder: 0px solid rgba(255, 255, 255, 0);\n\t}\n}\n\n.option-label {\n\talign-self: flex-start;\n\ttext-align: left;\n\tmargin: 0px 0px 0px 0px !important;\n\tfont-size: 15px;\n}\n\n.link {\n\ttext-decoration: none;\n\tcolor: #212529;\n\talign-self: flex-start;\n\tbackground-color: rgba(0, 0, 0, 0);\n\tpadding: 8px 12px 0px 12px;\n}\n\n.link:hover {\n\tcolor: #212529;\n}\n\n.label-button-logout {\n\talign-self: flex-end;\n\tcolor: rgba(143, 0, 60, 1);\n\tpadding: 0px;\n\tmargin: 0px;\n}\n\n.popover-header-user {\n\tbackground-color: rgba(255, 255, 255, 1);\n\tdisplay: flex;\n\talign-content: flex-start;\n\talign-items: flex-start;\n}\n\n.body-popover{\n\tborder: 0px solid rgba(0, 0, 0, 0);\n\tpadding: 5px;\n}\n\n.button-popover{\n\tborder: 0px solid rgba(0, 0, 0, 0);\n}\n\n.popover-box{\n\tborder-radius: 0px;\n}\n\n.header-username{\n\tdisplay: flex;\n\talign-content: center;\n}\n\n.header-username-arrow{\n\tcolor: $dark-red;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
